<template>
  <div
    class="h-3 w-full bg-gray-300 dark:bg-neutral-600"
    :style="{
      backgroundColor: bgColor,
      width: width,
      height: height,
      borderRadius: borderRadius
    }"
    :class="{ 'animate-pulse': !!animated, 'rounded-full': !borderRadius }"
  ></div>
</template>

<script setup lang="ts">
defineProps<{
  width?: string
  height?: string
  bgColor?: string
  animated?: boolean
  borderRadius?: string
}>()
</script>
